$(document).ready(function() {
	console.log('airtanks.js loaded');

	var currentlySelectedTank = null;

	makeTankSwatchTitlesSmall();

	addInMissingSwatches();

}); // end document.ready

function makeTankSwatchTitlesSmall(){
	console.log('makeTankSwatchTitlesSmall() called');
	$('.swatch_options .swatch.Style .swatch-element label').addClass('smaller');
	$('.swatch_options .swatch.Style .swatch-element').addClass('closer');
}

function addInMissingSwatches(){
	var currentSelections = getCurrentSelections();
	var [Style, Color, Size] = currentSelections.split(' / ');
	if (Style === "Logo" || Style === "Pig" || Style === "Pup") {
		// prepend original air tanks: woof, daddy, boy, blank
		prependOriginalAirTanks();
		$('.swatch_options input').on('change', function() {
			prependOriginalAirTanks();
		});
		changePageTitle('Air Tanks');
		changeSizingTitle('Air Tank Sizing:');
		addBlackOnlyText('* <b>Logo</b>, <b>Pig</b>, &amp; <b>Pup</b> Tanks are only available in <b>Black</b>');
	}else{
		// append new air tanks: logo, pig, pup
		appendNewAirTanks();
		$('.swatch_options input').on('change', function() {
			appendNewAirTanks();
		});
	}
}

function addBlackOnlyText(text){
	$('.swatch_options .swatch.Color').append(`<p class="black-only">${text}</p>`);
}

function changePageTitle(newTitle){
	$('.name_price h1.product_name').text(newTitle);
}

function changeSizingTitle(newTitle){
	$('#itemSizing h2').text(newTitle);
}

function prependOriginalAirTanks(){
	var currentSelections = getCurrentSelections();
	// currentSelections is a string like "Blank / Black / Small"
	var [Style, Color, Size] = currentSelections.split(' / ');

	console.log('prependOriginalAirTanks() currentSelections:', currentSelections);
	var urlToUse = "/products/gruff-pup-air-tanks";

	var originalAirTanks = {
		"Woof": {
		  "Black": {
			"Small": 40319810273335,
			"Medium": 40319810404407,
			"Large": 40319810437175,
			"X-Large": 40319810469943,
			"XX-Large": 40319810502711
		  }
		},
		"Daddy": {
		  "Black": {
			"Small": 40319811190839,
			"Medium": 40319811223607,
			"Large": 40319811256375,
			"X-Large": 40319811289143,
			"XX-Large": 40319811321911
		  }
		},
		"Boy": {
		  "Black": {
			"Small": 40319812010039,
			"Medium": 40319812042807,
			"Large": 40319812075575,
			"X-Large": 40319812108343,
			"XX-Large": 40319812141111
		  }
		},
		"Blank": {
		  "Black": {
			"Small": 41275458781239,
			"Medium": 41275458814007,
			"Large": 41275458846775,
			"X-Large": 41275458879543,
			"XX-Large": 41275458912311
		  }
		}
	  };

	$('.swatch_options .swatch.Style > a').remove();

	var putAfter = $('.swatch_options .swatch.Style .option_title');

	var order = ["Woof", "Daddy", "Boy", "Blank"];
	console.log('order:', order);
	for (let i = order.length - 1; i >= 0; i--) {
		console.log('i:', i);
		let styleKey = order[i];
		// Retrieve the product ID based on the current size for the "Black" color.
		if (!originalAirTanks[styleKey][Color]) { Color = "Black";console.log('Color changed to Black'); }
		if (!originalAirTanks[styleKey][Color][Size]) { Size = "Large"; console.log('Size changed to Large'); }
		var productID = originalAirTanks[styleKey][Color][Size];
		console.log('productID: ' + productID + ' from ' + styleKey + ' ' + Color + ' ' + Size);

		// Create the anchor element with the specified structure.
		var anchor = $(`
		<a href="${urlToUse}?variant=${productID}" value="${styleKey}" data-value="${styleKey}" data-id="${productID}" class="hover-scale-4 swatch-element closer ${styleKey}-swatch available">
			<label class="smaller">${styleKey}</label>
		</a>
		`);
		putAfter.after(anchor);
	};


}

function appendNewAirTanks(){
	var currentSelections = getCurrentSelections();
	// currentSelections is a string like "Blank / Black / Small"
	var [Style, Color, Size] = currentSelections.split(' / ');

	console.log('appendNewAirTanks() currentSelections:', currentSelections);
	var urlToUse = "/products/air-mesh-tanks-additional-styles";

	var newAirTanks = {
		"Logo": {
		  "Black": {
			"Small": 41479085326391,
			"Medium": 41479085359159,
			"Large": 41479085391927,
			"X-Large": 41479085424695,
			"XX-Large": 41479085457463
		  }
		},
		"Pig": {
		  "Black": {
			"Small": 41479086145591,
			"Medium": 41479086178359,
			"Large": 41479086211127,
			"X-Large": 41479086243895,
			"XX-Large": 41479086276663
		  }
		},
		"Pup": {
		  "Black": {
			"Small": 41479086964791,
			"Medium": 41479086997559,
			"Large": 41479087030327,
			"X-Large": 41479087063095,
			"XX-Large": 41479087095863
		  }
		}
	  };

	$('.swatch_options .swatch.Style > a').remove();

	var appendTo = $('.swatch_options .swatch.Style');

	var order = ["Logo", "Pig", "Pup"];
	for (let i = 0; i < order.length; i++) {
		let styleKey = order[i];
		// Retrieve the product ID based on the current size for the "Black" color.
		if (!newAirTanks[styleKey][Color]) { Color = "Black";console.log('Color changed to Black'); }
		if (!newAirTanks[styleKey][Color][Size]) { Size = "Large"; console.log('Size changed to Large'); }
		var productID = newAirTanks[styleKey][Color][Size];
		console.log('productID: ' + productID + ' from ' + styleKey + ' ' + Color + ' ' + Size);

		// Create the anchor element with the specified structure.
		var anchor = $(`
		<a href="${urlToUse}?variant=${productID}" value="${styleKey}" data-value="${styleKey}" data-id="${productID}" class="hover-scale-4 swatch-element ${styleKey}-swatch available">
			<label class="smaller">${styleKey}</label>
		</a>
		`);
		appendTo.append(anchor);
	};


}